// extracted by mini-css-extract-plugin
export default {"wrap":"error_wrap__p5C5Y","errorWrap":"error_errorWrap__udKuk","error":"error_error__HfJft"};